import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum MarketDataUsageReportsErrorStatesEnum {
    GetMarketDataUsageReportsFailed = ErrorStateScheduleEnum.MarketDataUsageReportStatesStartIndex,
    GetMarketDataUsageReportsNoData,
    GetUsersFailed,
    GetBundleFailed,
}
